import moment from "moment";

export const determineEventColor = (state, action) => {
  const defaultColor = "azure";
  const apptState = state;
  const apptAct = action;

  switch (apptState) {
    case "SCHEDULED":
      return "green";
    case "COMPLETED":
      return "azure";
    case "UNSCHEDULED":
      if (apptAct === "OFFERED") {
        return "orange";
      } else {
        return "red";
      }
    default:
      return defaultColor;
  }
};

export const determineEndTime = (durationValue, duration, start) => {
  let end = "";
  switch (Number(durationValue)) {
    case 60:
      end = moment(start).add(Number(duration), "h").toDate();
      return end;
    case 1:
      end = moment(start).add(Number(duration), "m").toDate();
      return end;

    default:
      end = moment(start).add(Number(duration), "h").toDate();
      return end;
  }
};
export const determineDuration = (durationValue, duration) => {
  let calculatedDuration = "";
  switch (Number(durationValue)) {
    case 60:
      calculatedDuration = `${duration} hr`;
      return calculatedDuration;
    case 1: {
      const numDuration = Number(duration) / 60;
      const converted = Math.round(numDuration * 100) / 100;
      //console.log(numDuration);

      calculatedDuration = `${converted} hr`;
      return calculatedDuration;
    }
    default:
      calculatedDuration = `${duration} hr`;

      return calculatedDuration;
  }
};

export const determineDateRange = (event) => {
  let range = {};
  //console.log("length: " + event.length);
  switch (event.length) {
    case 7:
      range = {
        low: moment(event[0]).format("YYYY-MM-DD"),
        lowMonth: moment(event[0]).format("YYYY-MM"),
        high: moment(event[6]).format("YYYY-MM-DD"),
        highMonth: moment(event[6]).format("YYYY-MM"),
      };
      return range;
    case 5:
      range = {
        low: moment(event[0]).format("YYYY-MM-DD"),
        lowMonth: moment(event[0]).format("YYYY-MM"),
        high: moment(event[4]).format("YYYY-MM-DD"),
        highMonth: moment(event[4]).format("YYYY-MM"),
      };
      return range;
    case 1:
      range = {
        low: moment(event[0]).format("YYYY-MM-DD"),
        lowMonth: moment(event[0]).format("YYYY-MM"),
        high: moment(event[0]).format("YYYY-MM-DD"),
        highMonth: moment(event[0]).format("YYYY-MM"),
      };
      return range;
    default:
      range = {
        low: moment(event.start).format("YYYY-MM-DD"),
        lowMonth: moment(event.start).format("YYYY-MM"),
        high: moment(event.end).format("YYYY-MM-DD"),
        highMonth: moment(event.end).format("YYYY-MM"),
      };
      return range;
  }
};

export const appointmentStartTimeFormat = (
  appointmentStartTime,
  end,
  duration
) => {
  const formattedEndTime = moment(end).format("LT");

  //const setDuration = moment.duration({ hours: duration });
  // const formattedDuration = moment(appointmentStartTime)
  //   .add(setDuration)
  //   .format("LT");
  const formattedStartTime = moment(appointmentStartTime).format(
    "dddd, MMMM Do [ - ] h:mm A[ - ]"
  );
  const formattedTime = formattedStartTime + formattedEndTime;

  return formattedTime;
};

export const appointmentStartTimeShortFormat = (
  appointmentStartTime,
  end,
  duration
) => {
  const formattedEndTime = moment(end).format("LT");
  const setDuration = moment.duration({ hours: duration });
  const formattedDuration = moment(appointmentStartTime)
    .add(setDuration)
    .format("LT");
  const formattedDate = moment(appointmentStartTime).format("ddd, MMM Do");
  const formattedStartTime = moment(appointmentStartTime).format("h:mm A[ - ]");
  //const formattedTime = formattedStartTime + formattedDuration;
  const formattedTime = formattedStartTime + formattedEndTime;
  const formatted = {
    date: formattedDate,
    time: formattedTime,
  };

  return formatted;
};
